import { GetCpntPjt } from "../../../services/component-projects";
import { CreateComponentDeploymentRequestsResponse } from "../../../services/deployment-requests";
import { Option } from "../../../util/option";

import { ErrorMessage } from "../../../util/spreadsheet-data-utils";

export type DeploymentRequestInfomationInputDialogState = {
  dplymntReqType: string;
  processTyp: string;
  deploymentRequestList: DeploymentRequestListNo[];
  createifListMap: CreateIfListMap[];
  updateifListMap: UpdateIfListMap[];
  componentMap: ComponentMap[];
  dplyImplType: string;
  dplymntDate: string;
  dplymntTime: string;
  generalCodes: GeneralCodes;
  isShow: boolean;
  isSaved: boolean;
  fieldPath: FieldPath;
  onCreateComponentDeploymentRequestError: (
    createComponentDeploymentRequest: CreateComponentDeploymentRequestsResponse,
  ) => void;
};

type CpntPjtList = {
  idx: number;
  isEdited: boolean;
  isChecked: boolean;
  message: string;
  cpntPjt: GetCpntPjt;
  /**
   * for error
   */
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};

type GeneralCode = {
  inDefCommonFlagType: Option[];
  tcktStsTypeCpntPrjPrgrs: Option[];
};

export type SpreadsheetState = {
  cpntPjtList: CpntPjtList[];
  generalCode: GeneralCode;
};

export type DeploymentRequestListNo = {
  dplymntReqSeq: string;
  updateDtimeTDplymntReqMng: string;
};
export type CreateIfListMap = {
  pjtId: string;
  ifList: CreateIfList[];
};
export type UpdateIfListMap = {
  pjtId: string;
  ifList: UpdateIfList[];
};
export type CreateIfList = {
  interfaceRequirementId: string;
  updateDTimeTIfReq: string;
  srcDstType: string;
  tcktId: string;
  interruptType?: string;
};
export type UpdateIfList = {
  interfaceRequirementId: string;
  updateDTimeTIfReq: string;
  srcDstType: string;
  tcktId: string;
  interruptType?: string;
};
export type ComponentMap = {
  index: number;
  pjtId: string;
  tcktId: string;
};
export type GeneralCodes = {
  deploymentDivisionType: Option[];
};
type FieldPath = {
  dplyImplType: string;
  dplymntDate: string;
  dplymntTime: string;
};
export type PageNewState =
  | DeploymentRequestInfomationInputDialogState
  | ((
      prevState: DeploymentRequestInfomationInputDialogState,
    ) => DeploymentRequestInfomationInputDialogState);
